import React from 'react';

export const ThemeContext = React.createContext<string>('light');
export const useThemeContext = () => React.useContext(ThemeContext);
